import { render, staticRenderFns } from "./Neuronios.vue?vue&type=template&id=560dee35&scoped=true&lang=pug&"
import script from "./Neuronios.vue?vue&type=script&lang=js&"
export * from "./Neuronios.vue?vue&type=script&lang=js&"
import style0 from "./Neuronios.styl?vue&type=style&index=0&id=560dee35&lang=stylus&scoped=true&"
import style1 from "./Neuronios.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560dee35",
  null
  
)

export default component.exports